import { useAuth } from 'wasp/client/auth';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function useRequireAdmin() {
  const { data: user, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;
    const isAdmin = user?.isAdmin === true;
    if (!isAdmin) navigate('/dashboard', { replace: true });
  }, [isLoading, user, navigate]);

  return { isLoading };
}